import { createSlice } from "@reduxjs/toolkit";
import _ from "lodash";
import { toast } from "react-toastify";
import { axiosApi } from "../../helpers/axios";

const initialStates = {
  error: {},
  loading: false,
  loginData: null,
  registerData: null,
  getProfileData: null,
};

/**
 * @param {LoginAPI}
 */
export const LoginAPI = (payload) =>
  async (dispatch) => {
    try {

      dispatch(authSetState([{ key: "loading", value: true }]));
      const response = await axiosApi.post(`/auth/login`, payload);

      if (response) {
        console.log("--------responseresponseresponseresponse-----", response);

        dispatch(
          authSetState([
            { key: "loading", value: false },
            { key: "error", value: {} },
            { key: "loginData", value: response?.data },
          ])
        );
      }
      return response;
    } catch (error) {

      dispatch(authSetState([{ key: "loading", value: false }]));
      toast.error(error?.response?.data?.error || "Error from backend side.");
      return error?.response?.data;
    }
  };


/**
 * @param {getProfileAPI}
 */
export const getProfileAPI = () =>
  async (dispatch) => {
    try {
      dispatch(authSetState([{ key: "loading", value: true }]));
      const response = await axiosApi.get(`/auth/profile`, null);

      if (response) {
        console.log("----response----", response);

        dispatch(
          authSetState([
            { key: "loading", value: false },
            { key: "error", value: {} },
            { key: "getProfileData", value: response },
          ])
        );
      }
      return response;
    } catch (error) {

      dispatch(authSetState([{ key: "loading", value: false }]));
      // toast.error(error?.response?.data?.error || "Error from backend side.");
      return error?.response?.data;
    }
  };

/**
 * @param {RegisterAPI}
 */
export const RegisterAPI = (payload) =>
  async (dispatch) => {
    try {
      dispatch(authSetState([{ key: "loading", value: true }]));
      const response = await axiosApi.post("/auth/register", payload);
      if (response) {
        dispatch(
          authSetState([
            { key: "loading", value: false },
            { key: "error", value: {} },
            { key: "registerData", value: response?.data },
          ])
        );
      }
      return response;
    } catch (error) {
      dispatch(authSetState([{ key: "loading", value: false }]));
      toast.error(error?.response?.data?.error || "Error from backend side.");
      return error?.response?.data;
    }
  };


// ** Create Slice
/**
 * @param {authSlice}
 */
const authSlice = createSlice({
  name: "auth",
  initialState: initialStates,
  reducers: {
    authSetState: (state, { payload }) => {
      if (Array.isArray(payload)) {
        for (const obj of payload) {
          _.set(state, obj.key, obj.value);
        }
      } else {
        _.set(state, payload.key, payload.value);
      }
    },
  },
});

export const { authSetState } = authSlice.actions;

const { reducer } = authSlice;

export default reducer;
